import { useState } from 'react';
import { CompontHeader } from './compont-header';
import { LinkPreview } from './link-preview';
import { Impressum } from './impressum';
import { DataPrivacy } from './data-privacy';

export const Footer = () => {
  const [openImpressum, setOpenImpressum] = useState(false);
  const [openDataPrivacy, setOpenDataPrivacy] = useState(false);

  return (
    <footer id="footer" className="mx-auto w-full max-w-7xl px-4 pt-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:text-left">
        <div>
          <CompontHeader text="Unternehmen" className="md:!justify-start" />
          <ul className="space-y-2">
            <li>
              <a href="#aboutUs" className="hover:underline">
                Über Uns
              </a>
            </li>
            <li>
              <a href="#contact" className="text-center hover:underline">
                Kontakt
              </a>
            </li>
            <li>
              <p
                onClick={() => setOpenDataPrivacy(true)}
                className="hover:underline cursor-pointer"
              >
                Datenschutzbestimmungen
              </p>
            </li>
            <li>
              {/* TODO: scrollt nicht!!!!! */}
              <p
                onClick={() => setOpenImpressum(true)}
                className="hover:underline cursor-pointer"
              >
                Impressum
              </p>
            </li>
          </ul>
        </div>

        <div className="text-center md:text-right">
          <CompontHeader text="Anschrift" className="md:!justify-end" />
          <ul className="space-y-2">
            <li>
              <a
                href="https://www.google.de/maps/place/T%C3%BCrkischer+Imbiss+%22Schmeckt+lecker!%22/@51.3704193,8.1677996,402m/data=!3m1!1e3!4m6!3m5!1s0x47bbe0c44fe030c9:0x6960d7710d0078a6!8m2!3d51.3703559!4d8.1699654!16s%2Fg%2F11cn2v91dd?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoJLDEwMjExMjM0SAFQAw%3D%3D"
                target="_blank"
                className="text-center mb-2 hover:underline"
              >
                Bahnhofstrasse 40, 59872 Meschede-Freienohl, Deutschland
              </a>
            </li>
            <li>
              <a href="tel:+492903449793" className="hover:underline">
                +49 2903 449793
              </a>
            </li>
            <li>
              <a
                href="mailto:info@schmeckt-lecker.net"
                className="hover:underline"
              >
                info@schmeckt-lecker.net
              </a>
            </li>
            <li>
              <LinkPreview
                url="https://www.facebook.com/schmecktleckerimbiB"
                className="hover:underline"
              >
                Facebook
              </LinkPreview>
            </li>
          </ul>
        </div>
      </div>
      <div className="mt-8 text-center text-sm border-t border-gray-800 py-4">
        © Schmeckt Lecker, Alle Rechte vorbehalten. Design by{' '}
        <LinkPreview url="https://twylo.net/" className="hover:underline">
          Twylo
        </LinkPreview>
      </div>
      <Impressum open={openImpressum} setOpen={setOpenImpressum} />
      <DataPrivacy open={openDataPrivacy} setOpen={setOpenDataPrivacy} />
    </footer>
  );
};
